import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {ContractLinkForm} from '../models/contract-link';
import {CommonField} from '../models/common-field';

export const linkContractUpdateActionTypes = {
  UPDATE: type('[Link Contract] Update'),
  UPDATE_SUCCESS: type('[Link Contract] Update Success'),
  UPDATE_FAIL: type('[Link Contract] Update Fail'),
};

export class UpdateLinkContractAction implements Action {
  readonly type = linkContractUpdateActionTypes.UPDATE;
  constructor(public payload?:  {form: ContractLinkForm , subList: CommonField[] }) {
  }
}
export class UpdateLinkContractSuccessAction implements Action {
  readonly type = linkContractUpdateActionTypes.UPDATE_SUCCESS;
  constructor(public payload?: boolean) {}
}

export class UpdateLinkContractFailAction implements Action {
  readonly type = linkContractUpdateActionTypes.UPDATE_FAIL;
  constructor(public payload?: string) {}
}
